import { Component, computed, input, output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { Button } from "primeng/button";
import { SvgIconComponent } from "@kernel/tools/svg-icon/components/svg-icon/svg-icon.component";
import { TSeverity } from "@kernel/shared/modules/button/types/severity.type";

@Component({
  selector: "sxw-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
  imports: [SvgIconComponent, TranslatePipe, Button],
})
export class ButtonComponent {
  type = input("button");
  label = input("");
  iconName = input<string | undefined | null>(undefined, { alias: "icon" });
  iconPos = input<"left" | "right" | "top" | "bottom">("left");
  iconWidth = input<string | null | undefined>("20");
  iconHeight = input<string | null | undefined>("20");
  isLoading = input(false);
  disabled = input(false);
  rounded = input(false);
  outlined = input(false);
  text = input(false);
  badge = input("");
  badgeClass = input("");
  theme = input("sxw-theme");
  styles = input({});
  leftIconFill = input<string | null | undefined>("black");
  rightIconFill = input<string | null | undefined>("black");
  iconStrokeColor = input<string | null | undefined>(null);
  iconStrokeWidth = input<string | null | undefined>(null);
  size = input<"small" | "large" | null | undefined>(null);
  severity = input<TSeverity>("primary");
  btnClasses = input<string[]>([]);

  mergedClasses = computed(() =>
    [...this.btnClasses(), this.size(), !this.label() || this.label() === "EMPTY" ? "p-button-icon-only" : ""].join(" ")
  );

  dt = input<Record<string, unknown>>();

  onClick = output<any>();

  click(event: MouseEvent) {
    this.onClick.emit(event);
  }
}
